<template>
  <div>
    <b-overlay
      :show="showOverlay"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <form-wizard
        color="#7367F0"
        :title="null"
        :subtitle="null"
        finish-button-text="Salvar Campanha"
        next-button-text="próximo"
        back-button-text="Voltar"
        class="steps-transparent mb-3"
        @on-complete="onSubmit()"
      >
        <!-- account details tab -->
        <tab-content
          title="Criar campanha"
          icon="feather icon-send"
        >
          <b-row>
            <b-col
              cols="12"
              class="mb-2"
            >
              <h5 class="mb-0">
                Campanha
              </h5>
              <small class="text-muted">
                Insira as informações da campanha
              </small>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="6">
              <b-form-group
                label="Nome da Campanha"
                label-for="nome-campaing"
              >
                <b-form-input
                  id="nome-campaing"
                  v-model="campaignName"
                  placeholder="Nome da sua Campanha"
                />
              </b-form-group>
            </b-col>
            <b-col md="6">
              <b-form-group
                label="Descrição da campanha"
                label-for="descricao-grupo"
              >
                <b-form-input
                  id="descricao-grupo"
                  v-model="campaignDescription"
                  placeholder="Descrição da Campanha"
                />
              </b-form-group>
            </b-col>
          </b-row>
        </tab-content>

        <!-- address -->
        <tab-content
          title="Leads"
          icon="feather icon-user"
        >
          <b-row>
            <b-col md="4">
              <div class="demo-inline-spacing">
                <b-form-radio
                  v-model="segmentType"
                  name="segmentType"
                  :value="0"
                >
                  Subir nova lista de leads
                </b-form-radio>
              </div>
            </b-col>
            <b-col md="4">
              <div class="demo-inline-spacing">
                <b-form-radio
                  v-model="segmentType"
                  name="segmentType"
                  :value="1"
                >
                  Selecionar lista de leads
                </b-form-radio>
              </div>
            </b-col>
            <b-col md="4">
              <div class="demo-inline-spacing">
                <b-form-radio
                  v-model="segmentType"
                  name="segmentType"
                  :value="2"
                >
                  buscar na plataforma
                </b-form-radio>
              </div>
            </b-col>
          </b-row>
          <br>

          <b-card v-if="this.segmentType === 0">
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <b-form-input
                    id="nome-grupo"
                    v-model="groupName"
                    placeholder="Nome da sua lista"
                  />
                </b-form-group>
              </b-col>
              <b-col md="6">
                <h4> 1️⃣ Escreva o nome da sua lista</h4>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col md="6">
                <!-- Styled -->
                <b-form-file
                  id="csv"
                  v-model="file"
                  placeholder="escolha seu arquivo csv..."
                  drop-placeholder="coloque seu arquivo aqui..."
                  accept=".csv"
                  type="file"
                />
              </b-col>
              <b-col md="6">
                <h4> 2️⃣ faça o upload da sua lista com máximo 5 mil leads.</h4>
              </b-col>
            </b-row>
            <hr>
            <b-row>
              <b-col
                md="6"
                class="text-bottom"
              >
                <b-button
                  variant="success"
                  style="margin-top: 3.5%;"
                  @click="getFile()"
                >
                  Carregar Lista
                </b-button>
              </b-col>
              <b-col md="6">
                <h4> 3️⃣ Carregue sua lista</h4>
              </b-col>
            </b-row>
            <br>
          </b-card>

          <b-row v-if="this.segmentType === 1">
            <b-col md="4">
              <b-form-group>
                <h5>Lista</h5>
                <b-form-select
                  v-model="lista"
                >
                  <option
                    :value="null"
                    disabled
                  >
                    -- Por favor, selecione uma lista --
                  </option>
                  <option
                    v-for="lista in listas.lists"
                    :value="lista.id"
                  >
                    {{ lista.name }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <b-card v-if="this.segmentType === 2">
            <b-row>
              <b-col md="6">
                <b-form-group
                  label="Nome do grupo"
                  label-for="nome-grupo"
                >
                  <b-form-input
                    id="nome-grupo"
                    v-model="groupName"
                    placeholder="Nome do seu grupo"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="4">
                <b-form-group>
                  <h5>Buscar por:</h5>
                  <v-select
                    v-model="searchType"
                    label="title"
                    placeholder="selecione o que você procura"
                    :options="optionSearchType"
                  />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <h5>Período</h5>
                  <flat-pickr
                    v-model="rangeDate"
                    class="form-control"
                    :config="{ mode: 'range'}"
                    placeholder="Selecione o período"
                  />
                </b-form-group>
              </b-col>
              <b-col
                v-if="searchType.id === 1"
                md="4"
              >
                <b-form-group>
                  <h5>Escolha a Região</h5>
                  <v-select
                    v-model="regionSelected"
                    multiple
                    placeholder="escolha a região"
                    label="title"
                    :options="books"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                v-if="searchType.id === 1"
                md="4"
              >
                <b-form-group>
                  <h5>Forma de Pagamento</h5>
                  <v-select
                    v-model="paymentSelected"
                    multiple
                    placeholder="escolha o método de pagamento"
                    label="title"
                    :options="paymentList"
                  />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group>
                  <h5>Gere a lista:</h5>
                  <b-button
                    variant="outline-primary"
                    @click="showConfirmList"
                  >
                    Gerar Lista
                  </b-button>
                </b-form-group>
              </b-col>

            </b-row>
          </b-card>

          <b-row v-if="fileList !== null">
            <b-col md="12">
              <app-collapse>

                <app-collapse-item title="Confira sua nova lista 👈">
                  <b-table
                    responsive="sm"
                    :items="fileList"
                  />
                </app-collapse-item>

              </app-collapse>
            </b-col>
          </b-row>

          <b-row v-if="this.leadsSearch.length > 0">
            <b-col md="12">
              <app-collapse>

                <app-collapse-item title="Confira sua nova lista 👈">
                  <b-table
                    responsive="sm"
                    :items="leadsSearch"
                  />
                </app-collapse-item>

              </app-collapse>
            </b-col>
          </b-row>

        </tab-content>

        <!-- personal details tab -->
        <tab-content
          title="Mensagem"
          icon="feather icon-file-text"
        >

          <b-row>
            <b-col>
              <div class="demo-inline-spacing">
                <b-form-group>
                  <b-form-checkbox
                    v-model="midiaBool"
                    value="true"
                    class="custom-control-primary"
                    @change="previewImage = null"
                  >
                    Adicionar midia
                  </b-form-checkbox>
                </b-form-group>
                <b-form-group>
                  <b-form-checkbox
                    v-model="buttonBool"
                    value="true"
                    class="custom-control-primary"
                  >
                    Adicionar link
                  </b-form-checkbox>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <hr>
          <b-row v-if="midiaBool">
            <b-col
              xl="8"
              cols="8"
            >
              <!-- Styled -->
              <b-form-group>
                <label for="textarea-auto-height">selecione a mídia</label>
                <b-form-file
                  v-model="midia"
                  type="file"
                  placeholder="escolha a mídia"
                  drop-placeholder="coloque sua mídia aqui..."
                  no-drop
                  plain
                  accept=".jpg, .png, .jpeg"
                  @change="uploadImage"
                />
              </b-form-group>
              <img
                style="max-width: 100%"
                :src="previewImage"
                class="uploading-image"
              >
              <hr>
            </b-col>
          </b-row>

          <b-row>
            <b-col
              xl="12"
              cols="12"
            >
              <label for="textarea-auto-height">Mensagem que será enviada:</label>
              <b-form-textarea
                id="textarea-state"
                v-model="message"
                rows="3"
                max-rows="3"
                :state="message.length <= maxChar"
                class="char-textarea"
                :class="message.length >= maxChar ? 'text-danger' : ''"
              />
              <small
                class="textarea-counter-value float-right"
                :class="message.length >= maxChar ? 'bg-danger' : ''"
              >
                <span class="char-count">{{ message.length }}</span> / {{ maxChar }}
              </small>
            </b-col>
          </b-row>
          <hr>
          <b-row v-if="buttonBool">
            <b-col
              xl="4"
              cols="4"
            >
              <b-form-group>
                <label for="InputHelp">Texto do botão</label>
                <b-form-input
                  id="InputHelp"
                  v-model="textButton"
                  maxlength="22"
                />
                <small class="text-muted"> {{ countString }}/22</small>
              </b-form-group>
              <hr>
            </b-col>
            <b-col
              xl="4"
              cols="4"
            >
              <b-form-group>
                <label for="InputHelp">
                  Link do botão
                  <b-badge
                    v-if="validLink"
                    pill
                    variant="light-success"
                  >URL válida!</b-badge>
                  <b-badge
                    v-if="!validLink && linkButton"
                    pill
                    variant="light-danger"
                  >URL inválida.</b-badge>
                </label>
                <b-form-input
                  id="input-valid1"
                  v-model="linkButton"
                  type="url"
                />
                <small class="text-muted"> ex.: <i>https://www.manyconvert.com</i></small>

              </b-form-group>
              <hr>
            </b-col>
          </b-row>

          <b-row
            v-if="type_campaign === 1"
          >
            <b-col
              xl="12"
              cols="12"
            >
              <label for="textarea-auto-height">Mensagem que será enviada:</label>
              <b-form-textarea
                id="textarea-state"
                v-model="message"
                rows="3"
                max-rows="3"
                :state="message.length <= maxChar"
                class="char-textarea"
                :class="message.length >= maxChar ? 'text-danger' : ''"
              />
              <small
                class="textarea-counter-value float-right"
                :class="message.length >= maxChar ? 'bg-danger' : ''"
              >
                <span class="char-count">{{ message.length }}</span> / {{ maxChar }}
              </small>
            </b-col>
          </b-row>
        </tab-content>
        <tab-content
          title="Revisão"
          icon="feather icon-check"
        >

          <b-row>
            <b-col
              xl="4"
              cols="4"
            >
              <b-form-group>
                <b-form-checkbox
                  v-model="scheduleBool"
                  value="true"
                  class="custom-control-primary"
                >
                  Programar envio da campanha
                </b-form-checkbox>
              </b-form-group>
              <b-form-group v-if="scheduleBool">
                <h5>Enviar a partir de:</h5>
                <flat-pickr
                  v-model="dateNtim"
                  class="form-control"
                  :config="{ enableTime: true, dateFormat: 'Y-m-d H:i:ss'}"
                  locale="pt"
                />
              </b-form-group>
            </b-col>
            <b-col
              xl="2"
              cols="2"
            />
            <b-col
              xl="4"
              cols="4"
              style="background-image: url('https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png');"
            >
              <b-card
                style="background-color: #d1fecf;  margin-top: 5%; "
                :footer="textButton"
                class="text-center"
                :img-src="previewImage"
              >
                <p class="text-left">
                  {{ message }}
                </p>
              </b-card>
            </b-col>
            <b-col
              xl="2"
              cols="4"
            />
          </b-row>

        </tab-content>
      </form-wizard>

      <b-overlay
        :show="busy"
        no-wrap
        @shown="onShown"
        @hidden="onHidden"
      >
        <template v-slot:overlay>
          <div
            v-if="processing"
            class="text-center p-4 bg-primary text-light rounded"
          >
            <b-icon
              icon="cloud-upload"
              font-scale="4"
            />
            <div class="mb-3">
              Processing...
            </div>
            <b-progress
              min="1"
              :max="max_pages"
              :value="counter"
              variant="success"
              height="3px"
              class="mx-n4 rounded-0"
            />
          </div>
          <div
            v-else
            ref="dialog"
            tabindex="-1"
            role="dialog"
            aria-modal="false"
            aria-labelledby="form-confirm-label"
            class="text-center p-3"
          >
            <p><strong id="form-confirm-label">Foram encontrados {{ info.total }} possiveis leads. Você deseja continuar?</strong></p>
            <div class="d-flex">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mr-3"
                @click="onCancel"
              >
                Não
              </b-button>
              <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="outline-success"
                @click="onOK"
              >
                Sim
              </b-button>
            </div>
          </div>
        </template>
      </b-overlay>

    </b-overlay>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import vSelect from 'vue-select'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormFile,
  BFormRadio,
  BFormSelect,
  BOverlay,
  BButton,
  BTable,
  BCard,
  BCardText,
  BCardTitle,
  BProgress,
  BIcon,
  BFormCheckbox,
  BTime,
  BBadge,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import flatPickr from 'vue-flatpickr-component'
import Ripple from 'vue-ripple-directive'
import { ref } from 'vue'
import axios from 'axios'
import magazord from '../../../functions/basics/magazord'
import teee from '../../../functions/basics/notifications'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BFormTextarea,
    BFormFile,
    BFormRadio,
    BFormSelect,
    BOverlay,
    BButton,
    BTable,
    AppCollapse,
    AppCollapseItem,
    BCard,
    BCardText,
    BCardTitle,
    flatPickr,
    BProgress,
    BIcon,
    BFormCheckbox,
    BTime,
    BBadge,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      testemensagem: null,
      midia: null,
      previewImage: null,
      scheduleBool: false,
      dateNtim: null,
      buttonLink: '',
      midiaBool: false,
      buttonBool: false,
      linkButton: null,
      textButton: '',
      type_campaign: 0,
      busy: true,
      paymentSelected: null,
      paymentList: [{ id: 1, title: 'boleto' }, { id: 2, title: 'pix' }, { id: 3, title: 'cartão de crédito' }],
      regionSelected: [],
      books: [
        {
          title: 'RS',
        },
        {
          title: 'SC',
        },
        {
          title: 'PR ',
        },
        {
          title: 'SP',
        },
        {
          title: 'RJ',
        },
        {
          title: 'MG',
        },
        {
          title: 'AC',
        },
        {
          title: 'AL',
        },
        {
          title: 'AP',
        },
        {
          title: 'AM',
        },
        {
          title: 'BA',
        },
        {
          title: 'CE',
        },
        {
          title: 'DF',
        },
        {
          title: 'ES',
        },
        {
          title: 'GO',
        },
        {
          title: 'MA',
        },
        {
          title: 'MT',
        },
        {
          title: 'MS',
        },
        {
          title: 'PA',
        },
        {
          title: 'PB',
        },
        {
          title: 'PE',
        },
        {
          title: 'PI',
        },
        {
          title: 'RN',
        },
        {
          title: 'RO',
        },
        {
          title: 'RR',
        },
        {
          title: 'SE',
        },
        {
          title: 'TO',
        },
      ],
      searchType: 0,
      optionSearchType: [{ id: 2, title: 'Cadastros' }], // {id: 1, title: "Clientes/aprovados"},
      rangeDate: null,
      maxChar: 1000,
      campaignDescription: null,
      lista: null,
      fileList: null,
      file: null,
      fileData: null,
      showOverlay: false,
      listas: [],
      groupName: null,
      segmentType: 1,
      message: '',
      campaignName: null,
      selectedContry: 'select_value',
      selectedLanguage: 'nothing_selected',
      countryName: [
        { value: 'select_value', text: 'Select Value' },
        { value: 'Russia', text: 'Russia' },
        { value: 'Canada', text: 'Canada' },
        { value: 'China', text: 'China' },
        { value: 'United States', text: 'United States' },
        { value: 'Brazil', text: 'Brazil' },
        { value: 'Australia', text: 'Australia' },
        { value: 'India', text: 'India' },
      ],
      languageName: [
        { value: 'nothing_selected', text: 'Nothing Selected' },
        { value: 'English', text: 'English' },
        { value: 'Chinese', text: 'Mandarin Chinese' },
        { value: 'Hindi', text: 'Hindi' },
        { value: 'Spanish', text: 'Spanish' },
        { value: 'Arabic', text: 'Arabic' },
        { value: 'Malay', text: 'Malay' },
        { value: 'Russian', text: 'Russian' },
      ],
      info: null,
      leadsSearch: [],
      counter: 1,
      interval: null,
      processing: false,
    }
  },
  computed: {
    countString() {
      return this.textButton.length ? this.textButton.length : 0
    },
    validLink() {
      if (this.linkButton) {
        return this.isValidHttpUrl(this.linkButton)
      }
    },
  },
  async created() {
    this.listas = await teee.getLists(this.$route.params.uuid)
  },
  methods: {
    async uploadFile() {
      const formData = new FormData()
      formData.append('file', this.fileData)

      try {
        const response = await axios.post('https://api-notifications.manyconvert.com/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        console.log(response)
        return response.data
      } catch (error) {
        console.log('deu erro')
      }
    },
    uploadImage(e) {
      const image = e.target.files[0]
      this.fileData = image
      const reader = new FileReader()
      reader.readAsDataURL(image)
      reader.onload = e => {
        this.previewImage = e.target.result
      }
    },
    onHidden() {
      // In this case, we return focus to the submit button
      // You may need to alter this based on your application requirements
      this.$refs.submit.focus()
    },
    onShown() {
      // Focus the dialog prompt
      this.$refs.dialog.focus()
    },
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    async onOK() {
      this.counter = this.info.page
      this.max_pages = this.info.total_pages
      this.processing = true
      // Simulate an async request
      this.clearInterval()

      const datas = this.rangeDate.split(' to ')
      while (this.info.has_more === true) {
        for (const lead of this.info.items) {
          if (lead.pessoaContato && lead.pessoaContato.length > 0) {
            this.leadsSearch.push({ name: lead.nome, phone: lead.pessoaContato[0].contato.replace(/\(|\/|\-|\s|\)/g, '') })
          }
        }

        this.info = await magazord.getCustomers(datas[0], datas[1], this.info.page + 1, this.$route.params.uuid)
        this.counter = this.info.page
      }

      this.clearInterval()
      this.$nextTick(() => {
        // eslint-disable-next-line
        this.busy = this.processing = false
      })
    },
    onCancel() {
      this.busy = false
    },
    async showConfirmList() {
      const datas = this.rangeDate.split(' to ')

      this.info = await magazord.getCustomers(datas[0], datas[1], 1, this.$route.params.uuid)

      if (this.info.total > 5000) {
        this.toast('danger', 'InfoIcon', 'Limite Excedido!', 'Parece que sua lista tem mais que 5000 linhas')
      } else {
        this.busy = true
      }
    },
    toast(variant, icon, title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          text,
          variant,
        },
      },
      {
        position: 'top-right',
      })
    },
    async getFile() {
      console.log('Entrou aqui')
      const fileInput = document.getElementById('csv')
      const reader = new FileReader()
      let createdList = []
      reader.onload = async () => {
        createdList = await this.createList(reader.result)
        this.fileList = createdList
      }
      reader.readAsBinaryString(fileInput.files[0])
    },
    async createCampaign() {
      const linkImage = this.midiaBool ? await this.uploadFile() : null
      const textButton = this.buttonBool ? this.textButton : null
      const linkButton = this.buttonBool ? this.linkButton : null
      const schedule = this.scheduleBool ? this.dateNtim : null

      await teee.createCampaign(this.campaignName, this.message, this.lista, linkImage, textButton, linkButton, schedule, this.$route.params.uuid)
        .then(resp => {
          if (resp.status === 200) {
            this.$swal({
              title: 'YEEEAH!',
              text: 'Sua campanha foi criada com sucesso! 🎉',
              icon: 'success',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            }).then(resp => window.location.href = `/campaign/${this.$route.params.uuid}/list`)
          } else {
            this.$swal({
              title: 'Algo deu errado! :(',
              text: 'Não foi possivel salvar a sua campanha, por favor, verefique os campos novamente.',
              icon: 'error',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
              buttonsStyling: false,
            })
            this.showOverlay = false
          }
        })
    },

    async createList(file) {
      const leads = []
      const lines = (file).split('\n')
      for await (const line of lines) {
        const lead = (line.replace(',', ';')).split(';')
        console.log(lead)
        if (lead[0] !== '' || lead[1] !== null || lead[1] !== undefined || lead[1] === '') {
          leads.push({ name: lead[0], phone: lead[1].replace(/\(|\/|\-|\s|\)/g, '') })
        }
      }
      return leads
    },
    async sendList(list) {
      const listInfos = await teee.createList(this.groupName, list.splice(1), this.$route.params.uuid)

      return listInfos.data.listId
    },
    async onSubmit() {
      if (this.campaignName === null || this.message === null || !(this.fileList || this.lista || this.leadsSearch)) {
        console.log(!(this.fileList || this.lista || this.leadsSearch))
        this.toast('warning', 'InfoIcon', 'OPS!', 'Nem todos os campos necessários foram preenchidos, ou a lista não foi carregada.')
      } else {
        this.showOverlay = true

        if (this.file !== null) {
          console.log('Arquivo: ', this.file)
          if (this.fileList.langht > 5000) {
            this.toast('danger', 'InfoIcon', 'Limite Excedido!', 'Parece que sua lista tem mais que 5000 linhas')
            this.file = null
            this.showOverlay = false
          } else {
            this.lista = await this.sendList(this.fileList)
          }
        }

        if (this.leadsSearch.length > 0) {
          console.log('leadsSearch: ', this.leadsSearch.langht)

          this.lista = await this.sendList(this.leadsSearch)
        }
        console.log(this.lista)
        if (this.lista) {
          this.createCampaign()
        }
      }
    },

    isValidHttpUrl(string) {
      try {
        const newUrl = new URL(string)
        return newUrl.protocol === 'http:' || newUrl.protocol === 'https:'
      } catch (err) {
        return false
      }
    },

  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-flatpicker.scss';

  .card-footer{
    color: #2e8c54;
  }
  .uploading-image{
     display:flex;
   }
</style>
